import { compose } from 'recompose'

import { connect } from 'react-redux';
import { listar } from '../../../../../../admin/ConsultaPerfisAdmin/actions'

const mapStateToProps = ({ PerfisAdminReducer }, props) => {

    const { comentario } = props
    let nomeUsuario = "";
    

    if (comentario && comentario.userUid) {
        if (!PerfisAdminReducer.rLista.loading && PerfisAdminReducer.rLista.lista) {
            PerfisAdminReducer.rLista.lista.forEach(element => {
                if (element.uid === comentario.userUid) {
                    
                    nomeUsuario = element.nome
                }
            });
        }
    }
    return { loading: PerfisAdminReducer.rLista.loading, perfis: PerfisAdminReducer.rLista.lista, nomeUsuario };
};



export default compose(
    connect(mapStateToProps, { listar })
)


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Comentarios/components/ItemComentario/ItemComentario.enhancer.js